module.exports = __webpack_public_path__ + "img/pdf_bg_quienes_somos.494abd57.png";